import React from 'react'
import { Checkbox, CheckboxProps } from 'semantic-ui-react'

import { PermissionGroup } from './PermissionGroup'
import { OnCheck } from './AllPermissions'

interface ProductPermissionsProps {
  onChange: (data: OnCheck) => void
  isChecked: (resource: string, actions: string[]) => boolean
}

export const ProductPermissions: React.FC<ProductPermissionsProps> = ({
  onChange,
  isChecked
}) => {
  function handleCheck(
    event: React.FormEvent<HTMLInputElement>,
    data: CheckboxProps
  ) {
    const value = data.value as string
    const checked = data.checked as boolean
    onChange({ value, checked })
  }

  return (
    <PermissionGroup label="Produto:">
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('product', ['Get', 'List'])}
        value="product:Get,List"
        label="Ler"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('product', ['Create'])}
        value="product:Create"
        label="Cadastrar"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('product', ['Update'])}
        value="product:Update"
        label="Atualizar"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('product', ['Delete'])}
        value="product:Delete"
        label="Excluir"
      />
    </PermissionGroup>
  )
}
